var map = {
	"./ErrorPages/404.vue": [
		"898f",
		"chunk-2d0df2e5"
	],
	"./Index/index.vue": [
		"fbaf",
		"chunk-1d2d626c",
		"chunk-3819e990"
	],
	"./advantage/components/Research.vue": [
		"a143",
		"chunk-763b5a50"
	],
	"./advantage/index.vue": [
		"3926",
		"chunk-260ef2ca",
		"chunk-6655168b"
	],
	"./company/index.vue": [
		"91f6",
		"chunk-260ef2ca",
		"chunk-8fa65c64",
		"chunk-3d5c8dd6"
	],
	"./cooperation/index.vue": [
		"fdee",
		"chunk-34063700"
	],
	"./home/index.vue": [
		"f5b8",
		"chunk-08d83679"
	],
	"./joins/components/MessageBox.vue": [
		"ab48",
		"chunk-71bc0c13"
	],
	"./joins/details.vue": [
		"3564",
		"chunk-260ef2ca",
		"chunk-1d2d626c",
		"chunk-ad1e942e"
	],
	"./joins/index.vue": [
		"268a",
		"chunk-260ef2ca",
		"chunk-1d2d626c",
		"chunk-6e67020e"
	],
	"./network/index.vue": [
		"3c62",
		"chunk-10c8e4c4"
	],
	"./news/details.vue": [
		"4706",
		"chunk-1d2d626c",
		"chunk-38fe5d26"
	],
	"./news/index.vue": [
		"9768",
		"chunk-260ef2ca",
		"chunk-1d2d626c",
		"chunk-c1585368"
	],
	"./products/components/Business.vue": [
		"ba37",
		"chunk-00cc0c83"
	],
	"./products/index.vue": [
		"b3a9",
		"chunk-260ef2ca",
		"chunk-44a10448"
	],
	"./staffStyle/index.vue": [
		"abdb",
		"chunk-260ef2ca",
		"chunk-8fa65c64",
		"chunk-14d7bb05"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a2f9";
module.exports = webpackAsyncContext;